<template>
    <div class="events games-multi container-screen">
        <LoadingScreen v-if="loadingPage" />
        <template v-else>
            <div class="events__body">
                <TitleCommon :value="`${getTranslatedText(this.dataGames?.game?.name || 'Pick 3')}`" />
                <template v-if="dataSourceDrawWeek.length > 0 || dataSourceFilter.length > 0">
                    <SelectFilter />
                    <div class="loto__list__head__button events__butoon-select">
                        <button @click="onSelectAll">{{ getTranslatedText('Select All') }}</button>
                    </div>
                    <div class="events__content">
                        <div class="events__list">
                            <h3 v-show="dataSourceDrawWeek.length > 0" class="event__list-title">
                                {{ getTranslatedText('draw this week') }}
                            </h3>
                            <div
                                v-for="(v, i) in dataSourceDrawWeek"
                                :key="v.draw_date"
                                class="events__item pick-3 same-week"
                                :class="{
                                    active: eventSelect.includes(v.event_id),
                                    mb: dataSourceDrawWeek.length === i + 1,
                                }"
                                @click="onSelectEvent(v.event_id, v)"
                            >
                                <span class="events__item-date">
                                    {{ renderDayOfWeek(v.draw_date) }} {{ renderDate(v.draw_date) }}
                                </span>
                            </div>
                            <h3 v-show="dataSourceFilter.length > 0" class="event__list-title">
                                {{ getTranslatedText('next draws') }}
                            </h3>
                            <div
                                v-for="(v, i) in dataSourceFilter"
                                class="events__item pick-3"
                                :class="{ active: eventSelect.includes(v.event_id) }"
                                :key="i"
                                @click="onSelectEvent(v.event_id, v)"
                            >
                                <span class="events__item-date">
                                    {{ renderDayOfWeek(v.draw_date) }} {{ renderDate(v.draw_date) }}
                                </span>
                            </div>
                        </div>
                        <div class="events_box-button">
                            <button @click="$router.push('/')" class="button button__active no-hover">
                                {{ getTranslatedText('back') }}
                            </button>
                            <ButtonCommon
                                type="error"
                                :isNoHover="true"
                                :class-name="'button__continue pick-3'"
                                value="continue"
                                :isLoading="isLoadingButton"
                                @on-click-button-common="onEventContinue"
                            />
                        </div>
                    </div>
                </template>
                <div class="events__empty" v-else>{{ getTranslatedText('empty game') }}</div>
            </div>
        </template>
    </div>
</template>

<script>
import { formatDateUTC00, isArrayEmpty, isCurrentWeek, getDayOfWeek } from '@/utils/utils'

import GamesService from '@/services/games.service'
import LastResultService from '@/services/last-result.service'
import pathAssetsMixins from '@/mixins/pathAssets/path-assets-mixins'
import languageMixins from '@/mixins/language/language-mixins'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'
import TitleCommon from '@/components/common/title/index.vue'
import SelectFilter from '@/components/gamesPick3/events/select/index.vue'
import { CT_PICK_3 } from '@/constants/lotto'

export default {
    mixins: [pathAssetsMixins, languageMixins],
    components: { ButtonCommon, SelectFilter, LoadingScreen, TitleCommon },
    data() {
        return {
            dataSource: [],
            dataSourceDrawWeek: [],
            dataSourceFilter: [],
            eventSelect: [],
            eventInfo: [],
            loadingPage: true,
            isLoadingButton: false,
            dataGames: [],
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                const respGames = await GamesService.getListGames(CT_PICK_3.URL_TYPE_API)
                const respEvent = await GamesService.getListEvents(CT_PICK_3.URL_TYPE_API + '/api')
                LastResultService.writeScheduleFromGames('fixed-daily-lotto', respGames)
                if (!isArrayEmpty(respGames.data) && !isArrayEmpty(respEvent.data)) {
                    const dataDraws = respEvent.data
                    const dataGamesFilterFollowSlug = respGames.data.filter((x) => x.game.slug === CT_PICK_3.SLUG_GAME)

                    this.dataSourceDrawWeek = dataDraws.filter((x) => this.isCheckDrawThisWeek(x.draw_date))
                    const lengthData = this.dataSourceDrawWeek.length > 0 ? 7 : 8
                    this.dataSourceFilter = dataDraws
                        .filter((x) => !this.isCheckDrawThisWeek(x.draw_date))
                        .slice(0, lengthData)

                    this.dataSource = dataDraws.splice(0, lengthData + 1)
                    this.dataGames = dataGamesFilterFollowSlug?.[0] || []
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingPage = false
            }
        },

        onSelectAll() {
            if (this.dataSource.length === this.eventSelect.length) {
                this.eventSelect = []
                this.eventInfo = []
            } else {
                this.dataSource.forEach((item) => {
                    const index = this.eventSelect.findIndex((x) => x === item.event_id)
                    if (index === -1) {
                        this.eventSelect.push(item.event_id)
                        this.eventInfo.push({
                            name: item.draw_name,
                            date: item.draw_date,
                        })
                    }
                })
            }
        },

        onSelectEvent(eventId, item) {
            const index = this.eventSelect.findIndex((x) => x === eventId)
            if (index !== -1) {
                this.eventSelect.splice(index, 1)
                this.eventInfo.splice(index, 1)
            } else {
                this.eventSelect.push(eventId)
                this.eventInfo.push({
                    name: item.draw_name,
                    date: item.draw_date,
                })
            }
        },

        isCheckDrawThisWeek(date) {
            return isCurrentWeek(date)
        },

        renderDate(date) {
            const dateFormat = formatDateUTC00(date)

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}H${dateFormat.minutes}`

            return valueDate
        },

        onEventContinue() {
            if (isArrayEmpty(this.eventSelect)) {
                const param = {
                    text: 'Please choose the game',
                    type: 'warning',
                }
                EventBus.$emit('show-notications', param)

                return false
            } else {
                const { game, markets } = this.dataGames

                const param = {
                    title: game?.name || CT_PICK_3.TITLE_GAME,
                    game: game?.slug || CT_PICK_3.SLUG_GAME,
                    event_id: this.eventSelect,
                    eventInfo: this.eventInfo,
                    selection: [],
                    markets,
                }

                localStorage.setItem(CT_PICK_3.LOCAL_STORAGE_KEY, JSON.stringify(param))
                this.$router.push(CT_PICK_3.URL_PATH_NUMBER)
            }
        },

        renderDayOfWeek(drawDate) {
            const dayOfWeek = getDayOfWeek(drawDate)
            return this.getTranslatedText(dayOfWeek)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_event.scss';
</style>
